module.exports = __webpack_public_path__ + "img/cespiti_emt.1309838a.png";